export default {
  name: 'work-bench',
  path: 'work-bench',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '工作台',
    redirect: true,
    icon: 'icon-a-jianqu20',
    hideBreadcrumb: true,
    noLimits: true,
  },
  children: [
    {
      name: 'work-bench-index',
      path: '',
      component: () => import('@/views/work-bench/WorkBench.vue'),
      meta: {title: '', icon: 'icon-a-jianqu20', hideBreadcrumb: true, noLimits: true},
    },
    {
      name: 'todo-task',
      path: 'todo-task',
      component: () => import('@/views/work-bench/TodoTask.vue'),
      meta: {title: '', icon: 'icon-a-jianqu20', hideBreadcrumb: true, noLimits: true},
    },
    {
      name: 'historical-task-record',
      path: 'historical-task-record',
      component: () => import('@/views/work-bench/HistoricalTaskRecord.vue'),
      meta: {title: '', icon: 'icon-a-jianqu20', hideBreadcrumb: true, noLimits: true},
    },
  ]
};
